import PropTypes from "prop-types"
import { Fragment } from "react"
import useCanvas from "./hooks/use-canvas"
import useDesigner from "./hooks/use-designer"
import handleDownload from "./helpers/handle-download"
import styled, { css } from "styled-components"
import { up } from "styled-breakpoints"
import { CANVAS_SIZE } from "./helpers/base-options"

const ImageDesignerContainer = styled.div`
  width: 100%;
  .canvas-container {
    margin: 0 auto;
    max-width: ${CANVAS_SIZE}px;
    width: 100% !important;
    font-family: "Open Sans Condensed", sans-serif;
    canvas {
      width: 100% !important;
      ${up("lg")} {
        width: auto;
      }
    }

    ${up("lg")} {
      width: auto;
    }
  }

  ${(p) =>
    p.isLoading
      ? css`
          position: relative;

          &::after,
          &::before {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
          }

          &::after {
            content: " ";
            background-color: rgba(255, 255, 255, 0.75);
          }

          &::before {
            content: attr(data-spin-text);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 2;
            color: var(--selected-color);
            font-size: 1.8rem;
            letter-spacing: 1px;
            font-style: italic;
          }
        `
      : null}
`

const ImageDesigner = ({
  children,
  placeholder,
  src,
  logoImg,
  logo,
  onChangePreview,
  thumbnailSrc,
  modelName,
  logoDimensions,
}) => {
  const canvasRef = React.useRef(null)
  const { canvas, size, isResizing } = useCanvas(canvasRef)
  const placeholderOpts = placeholder || logo

  const { loading, getPreview } = useDesigner(canvas, {
    bgSrc: src,
    bgThumbnailSrc: thumbnailSrc,
    logoSrc: logoImg,
    logoOpts: logo,
    placeholderOpts,
    onChangePreview,
    logoDimensions,
    size,
  })

  React.useEffect(() => {
    return () => {
      if (canvas) {
        // clear canvas instance
        canvas.dispose()
      }
    }
  }, [canvas])

  const onDownload = async () => {
    const img = await getPreview(canvas, {
      src: thumbnailSrc,
      logo: logoImg,
      placeholderOpts,
      size,
    })

    return handleDownload(img, modelName)
  }

  return (
    <Fragment>
      <ImageDesignerContainer
        data-spin-text={isResizing ? "Resizing" : "Loading"}
        isLoading={loading || isResizing}
      >
        <canvas ref={canvasRef} />
      </ImageDesignerContainer>
      <h4>
        <strong>Model: {modelName}</strong>
      </h4>
      {children({ onDownload, canvas })}
    </Fragment>
  )
}

ImageDesigner.propTypes = {
  children: PropTypes.func,
  placeholder: PropTypes.object,
  logo: PropTypes.object.isRequired,
  logoImg: PropTypes.string,
  imgRootPath: PropTypes.string,
}

ImageDesigner.defaultProps = {
  logoImg: null,
}
export default ImageDesigner
